<template>
  <v-app>
    <v-main>
      <div class="layout-container">
        <appBar v-if="shouldShowAppBar" class="app-bar" />
        <router-view class="router-view" />
        <fooTer class="footer" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import appBar from "./components/AppBar.vue";
import fooTer from "./components/MainFooter.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  components: { appBar, fooTer },
  setup() {
    const route = useRoute();

    const excludedRoutes = ["/login", "/register", "/recover-password"];

    const shouldShowAppBar = computed(() => {
      return !excludedRoutes.includes(route.path);
    });

    return {
      shouldShowAppBar,
    };
  },
};
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.app-bar {
  flex-shrink: 0;
}

.router-view {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.footer {
  flex-shrink: 0;
  position: relative;
}
</style>
